export const TEAM = [
  {
    id: 1,
    name: 'LGers',
    link: 'https://github.com/LGers',
    avatar: 'https://avatars.githubusercontent.com/u/87089817?v=4',
  },
  {
    id: 2,
    name: 'lukashkinamarina',
    link: 'https://github.com/lukashkinamarina',
    avatar: 'https://avatars.githubusercontent.com/u/86889005?v=4',
  },
  {
    id: 3,
    name: 'sergioivanov008',
    link: 'https://github.com/sergioivanov008',
    avatar: 'https://avatars.githubusercontent.com/u/74328346?s=400&v=4',
  },
];

export const FOOTER_DATA = {
  FOOTER_YEAR: '© 2022',
  FOOTER_LINK: 'https://rs.school/js/',
  FOOTER_LOGO: 'https://rs.school/images/rs_school_js.svg',
};
